import { Drawer, Button, Checkbox } from "antd";
import { TeamOutlined, CloseOutlined, AppstoreAddOutlined, ExpandAltOutlined } from "@ant-design/icons";

const MergeSplitDrawer = ({
  mergeDrawerOpen,
  closeMergeDrawer,
  tableList,
  mergeOrSplitAction,
  setMergeOrSplitAction,
  selectedTablesForMerge,
  setSelectedTablesForMerge,
  handleTableSelection,
  handleActionChange,
  handleMergeTables,
  handleSplitTableClick,
  isNormalAvailableTable,
  getSplitSubTables,
}) => {
  return (
    <Drawer
      open={mergeDrawerOpen}
      onClose={() => {
        closeMergeDrawer();
        setSelectedTablesForMerge([]);
        setMergeOrSplitAction("merge");
      }}
      width="70%"
      styles={{ mask: { backgroundColor: "rgba(0,0,0,0.3)" } }}
      styles={{ body: {
        padding: "0px",
        background: "#fff",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      } }}
      styles={{ header: { display: "none" } }}
    >
      {/* Close Icon */}
      <div
        style={{
          position: "absolute",
          right: 20,
          top: 20,
          cursor: "pointer",
          fontSize: 20,
          color: "#444",
          zIndex: 10,
        }}
        onClick={() => {
          closeMergeDrawer();
          setSelectedTablesForMerge([]);
          setMergeOrSplitAction("merge");
        }}
      >
        <CloseOutlined />
      </div>

      {/* -------- FIXED TOP SECTION -------- */}
      <div style={{ padding: "25px 40px 10px" }}>
        <h1 style={{ fontSize: "20px", fontWeight: 600, marginBottom: 5 }}>Merge / Split Tables</h1>
        <p style={{ fontSize: 13, color: "#6B7280", marginBottom: 10 }}>
          Manage table combinations and divisions
        </p>

        <h3 style={{ marginBottom: 12, fontSize: 15, fontWeight: 600 }}>Select Action</h3>

        {/* Merge Option */}
        <div
          style={{
            border: mergeOrSplitAction === "merge" ? "2px solid #2563EB" : "1px solid #D1D5DB",
            borderRadius: 10,
            padding: "14px",
            marginBottom: 10,
            display: "flex",
            alignItems: "center",
            gap: 15,
            cursor: "pointer",
            background: mergeOrSplitAction === "merge" ? "#DBEAFE" : "#F9FAFB",
          }}
          onClick={() => handleActionChange("merge")}
        >
          <Checkbox checked={mergeOrSplitAction === "merge"} style={{ pointerEvents: "none" }} />
          <div
            style={{
              width: 42,
              height: 42,
              borderRadius: "50%",
              background: "#E0F2FE",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 20,
            }}
          >
            <AppstoreAddOutlined />
          </div>
          <div>
            <div style={{ fontSize: 15, fontWeight: 600 }}>Merge Tables</div>
            <div style={{ fontSize: 12, color: "#6B7280" }}>
              Combine multiple table bills into one unified table
            </div>
          </div>
        </div>

        {/* Split Option */}
        <div
          style={{
            border: mergeOrSplitAction === "split" ? "2px solid #2563EB" : "1px solid #E5E7EB",
            borderRadius: 10,
            padding: "14px",
            marginBottom: 20,
            display: "flex",
            alignItems: "center",
            gap: 15,
            cursor: "pointer",
            background: mergeOrSplitAction === "split" ? "#DBEAFE" : "#fff",
          }}
          onClick={() => handleActionChange("split")}
        >
          <Checkbox checked={mergeOrSplitAction === "split"} style={{ pointerEvents: "none" }} />
          <div
            style={{
              width: 42,
              height: 42,
              borderRadius: "50%",
              background: "#FFEFE1",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 20,
            }}
          >
            <ExpandAltOutlined />
          </div>
          <div>
            <div style={{ fontSize: 15, fontWeight: 600 }}>Split Table</div>
            <div style={{ fontSize: 12, color: "#6B7280" }}>
              Divide current table into separate sub-tables
            </div>
          </div>
        </div>

        <h3 style={{ marginBottom: 6, fontSize: 15, fontWeight: 600 }}>
          {mergeOrSplitAction === "merge" ? "Select Tables to Merge" : "Select Table to Split"}
        </h3>
        <p style={{ marginBottom: 10, fontSize: 12, color: "#6B7280" }}>
          {mergeOrSplitAction === "merge"
            ? "Choose 2 or more available tables"
            : "Choose one available table to split"}
        </p>
      </div>

      {/* -------- SCROLLABLE TABLE LIST -------- */}
      <div style={{ flex: 1, overflowY: "auto", padding: "0px 40px 120px" }}>
        {(() => {
          const splitSubTables = mergeOrSplitAction === "merge" && getSplitSubTables
            ? getSplitSubTables()
            : [];

          const normalTables = tableList.filter(isNormalAvailableTable);
          const allRows = [...normalTables, ...splitSubTables];

          // For split action - exclude split sub-table rows from list
          const filteredRows = mergeOrSplitAction === "split"
            ? allRows.filter((tbl) => !tbl.isSplitRow)
            : allRows;

          if (filteredRows.length === 0) {
            return (
              <p style={{ textAlign: "center", color: "#888", marginTop: 40 }}>
                No available tables
              </p>
            );
          }

          return filteredRows.map((tbl, i) => {
            const isSelected = selectedTablesForMerge.includes(tbl.cwrFbTableId);
            return (
              <div
                key={i}
                onClick={() => handleTableSelection(tbl.cwrFbTableId)}
                style={{
                  border: "1px solid #E5E7EB",
                  borderRadius: 10,
                  padding: "14px",
                  marginBottom: 5,
                  display: "flex",
                  alignItems: "center",
                  gap: 15,
                  cursor: "pointer",
                  background: isSelected ? "#DBEAFE" : "#F9FAFB",
                  borderColor: isSelected ? "#2563EB" : "#E5E7EB",
                  transition: "0.2s",
                }}
              >
                <Checkbox checked={isSelected} style={{ pointerEvents: "none" }} />
                <div style={{ flex: 1 }}>
                  <strong style={{ fontSize: 16 }}>{tbl.name}</strong>
                  {tbl.isSplitRow && (
                    <span style={{
                      marginLeft: 8,
                      fontSize: 11,
                      background: "#FEF3C7",
                      color: "#92400E",
                      padding: "2px 8px",
                      borderRadius: 10,
                      fontWeight: 500,
                    }}>
                      Split
                    </span>
                  )}
                  <div style={{ marginTop: 5, color: "#444", fontSize: 13 }}>
                    <TeamOutlined style={{ marginRight: 6 }} />
                    Capacity: {tbl.capacity || 0} • {tbl.sectionName}
                  </div>
                </div>
                <div style={{ fontSize: 16, fontWeight: 600, color: "#10B981" }}>Available</div>
              </div>
            );
          });
        })()}
      </div>

      {/* -------- FIXED FOOTER -------- */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          background: "#fff",
          padding: "12px 30px",
          borderTop: "1px solid #E5E7EB",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button
          style={{ height: 40, borderRadius: 8 }}
          onClick={() => {
            closeMergeDrawer();
            setSelectedTablesForMerge([]);
            setMergeOrSplitAction("merge");
          }}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          disabled={
            mergeOrSplitAction === "merge"
              ? selectedTablesForMerge.length < 2
              : selectedTablesForMerge.length !== 1
          }
          style={{
            height: 40,
            background:
              (mergeOrSplitAction === "merge" && selectedTablesForMerge.length >= 2) ||
              (mergeOrSplitAction === "split" && selectedTablesForMerge.length === 1)
                ? "#374151"
                : "#9CA3AF",
            borderRadius: 8,
            width: "180px",
            fontWeight: 600,
          }}
          onClick={mergeOrSplitAction === "merge" ? handleMergeTables : handleSplitTableClick}
        >
          {mergeOrSplitAction === "merge"
            ? `Merge ${selectedTablesForMerge.length} Tables`
            : "Split Table"}
        </Button>
      </div>
    </Drawer>
  );
};

export default MergeSplitDrawer;
